import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

// function createData(name, calories, fat, carbs, protein) {
//   return { name, calories, fat, carbs };
// }

// const rows = [createData("Individual Registration", 159, 6.0, 24)];

export default function BasicTable({
  description,
  quantity,
  rate,
  accomodation,
  accomodationFee,
}) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 350 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Description</TableCell>
            <TableCell align="right">Quantity</TableCell>
            <TableCell align="right">Rate</TableCell>
            <TableCell align="right">Amount</TableCell>
            {/* <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {/* {rows.map((row) => ( */}
          <TableRow
            // key={row.name}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          >
            <TableCell component="th" scope="row">
              {description}
            </TableCell>
            <TableCell align="right">{quantity}</TableCell>
            <TableCell align="right">{rate}</TableCell>
            <TableCell align="right">{quantity * rate}</TableCell>
          </TableRow>
          {accomodation && (
            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                Accomodation Fee
              </TableCell>
              <TableCell align="right">{accomodation | ""}</TableCell>
              <TableCell align="right">{accomodationFee | ""}</TableCell>
              <TableCell align="right">{(accomodation * accomodationFee) | ""}</TableCell>
            </TableRow>
          )}
          {/* ))} */}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
